module.exports = __webpack_public_path__ + "static/media/SY DSA II.e784e944.jpeg";